import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { highlandParkConfig } from "./data";

export default function HighlandParkPage() {
  return <CityPageTemplate config={highlandParkConfig} />;
}